export default "__VITE_ASSET__DUuPNu3U__"